gsap.registerPlugin(ScrollTrigger);

const animatedElements = document.querySelectorAll('.animated-text');

animatedElements.forEach(el => {
  gsap.fromTo(el, 
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1,
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        toggleActions: 'play none none reverse',
        markers: false,
      }
    }
  );
});

const block = document.querySelector('.duration-block');

gsap.to(block, {
  scrollTrigger: {
      trigger: block,
      start: 'top 100%',
      toggleActions: 'play none none none',
      onEnter: () => block.classList.add('active'),
      onLeaveBack: () => block.classList.remove('active'),
      markers: false,
    },
  }
);

function initParallax() {
  const parallaxSections = document.querySelectorAll('.parallax');

  parallaxSections.forEach((section, i) => {
    const bg = section.querySelector('.bg'); 
    const isVideo = bg instanceof HTMLVideoElement;
    const coef = isVideo ? 0.4 : 0.1;
    
    gsap.fromTo(bg, {
      top: () => i ? `${-section.offsetHeight * coef + 'px'}` : '0px'
    }, {
      top: () => `${section.offsetHeight * coef + 'px'}`,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: () => i ? 'top bottom' : 'top top', 
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  
  });
}

initParallax();
